import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { axiosInstance } from "../axios-instance";

class FileTypeConfigurationV2 {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  uploadBulkCSV(
  file: File | Blob
): Promise<AxiosResponse<any>> {
  const accessToken = localStorage.getItem('accessToken');
  const formData = new FormData();
  formData.append('file', file);

  return axiosInstance.post<any>(`${this.baseUrl}/bulkFileTypeConfigs`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'multipart/form-data',
    },
  })
  .catch((error) => {
    throw error;
  });
}
}
export default FileTypeConfigurationV2;